<template>
  <router-view v-if="shouldRenderView"></router-view>
</template>

<script>
import { checkNotificationPermisson } from "@/helpers/firebase";
import { MultiSelect, CheckBoxSelection } from "@syncfusion/ej2-dropdowns";
import { mapActions, mapGetters } from "vuex";
import { store } from "@/store";
import { forbidden_router_name } from "./routes/routes";
import { getId } from "@/helpers/utils";
import { hasValidRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";
import KeycloakLib from "@/libs/Keycloak";

MultiSelect.Inject(CheckBoxSelection);

export default {
  data() {
    return {
      shouldRenderView: false
    };
  },
  computed: {
    ...mapGetters("schoolAuth", ["isAuthenticated"]),
    ...mapGetters("user", {
      userInfo: "info"
    })
  },
  methods: {
    ...mapActions("user", ["FetchUserInformation"]),
    ...mapActions("fcm", ["FetchTotalNotify"]),
    ...mapActions("switchAccountChild", ["setDefaultChildAccounts"]),
    ...mapActions("schoolAuth", ["Logout"])
  },
  mounted() {
    const self = this;
    document.addEventListener("visibilitychange", function() {
      if (self.userInfo && document.visibilityState === "visible") {
        self.FetchTotalNotify(getId(self.userInfo));
      }
    });
  },
  created() {
    if (this.isAuthenticated) {
      this.FetchUserInformation()
        .then(() => {
          const userRole = store.getters["user/role"];
          const userInfo = store.getters["user/info"];
          const userCfg = { userRole: userRole };

          // ? for route permission
          if (
            this.$route.meta.activeRoute &&
            !this.$route.meta.activeRoute(userCfg)
          ) {
            this.$router.push({ name: forbidden_router_name });
          }

          // ? for notification
          checkNotificationPermisson(userInfo);

          return;
        })
        .catch(() => {
          // who-am-i tu choi (vd: tai khoan Inactive o truong nay) - axios
          // helper da hien toast loi, o day chi can dang xuat sach de tranh
          // ket qua trang/hong voi userInfo rong thay vi giu nguyen trang
          // bi loi.
          KeycloakLib.doLogout();
          this.Logout();
        })
        .finally(() => {
          this.shouldRenderView = true;
        });
      return;
    }

    this.shouldRenderView = true;
  }
};
</script>

// For Multi select
<style>
@import "../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
</style>
